import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { authLoginRoute } from './auth.routes';
import type { HorizonAppLoaderContext } from '#/horizon/types/horizon-app-loader-context';

type Args = {
  request: Request;
  context: HorizonAppLoaderContext;
};

export function idealistRequireAuthentication({ request, context }: Args) {
  const url = new URL(request.url);

  return idealistRedirect({
    request,
    context,
    to: authLoginRoute.with({
      to: `${url.pathname}${url.search}`,
      auth_required: 1,
    }),
    status: 302,
  });
}
